module.exports = __webpack_public_path__ + "img/zy-jy-bj.783237ba.png";